import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useI18n } from "../../../i18n";
import { fmtDate } from "../../../lib/format";
import { useApi } from "../../customer/hooks";

export default function PickingList() {
  const { t } = useI18n();
  const [sp] = useSearchParams();
  const q = useApi("warehouse", "/staff/orders/warehouse");
  const g = (q.data || []).find((x) => String(x.date) === sp.get("date") && x.area_code === sp.get("area"));

  useEffect(() => {
    if (g) setTimeout(() => window.print(), 400);
  }, [g]);

  if (!g) return <p className="p-8 text-sm text-slate-500">{q.isLoading ? t("common.loading") : t("ops.noWarehouse")}</p>;
  const totals = {};
  g.orders.forEach((o) => o.items.forEach((i) => { const k = `${i.item_code}:${i.uom || "box"}`; totals[k] = { ...i, key: k, qty_boxes: (totals[k]?.qty_boxes || 0) + i.qty_boxes }; }));
  const u = (i) => t(i.uom === "piece" ? "x.uom.piece" : "x.uom.box");
  return (
    <div className="mx-auto max-w-3xl bg-white p-8 text-navy print:p-0" data-testid="picking-list">
      <h1 className="text-2xl font-bold">{t("ops.pickingList")} · {fmtDate(g.date)} · {g.area_name}</h1>
      <h2 className="mt-6 text-sm font-semibold uppercase tracking-wider text-slate-500">{t("ops.totalBoxes")}</h2>
      <table className="mt-2 w-full border-collapse text-sm">
        <tbody>{Object.values(totals).sort((a, b) => a.item_code.localeCompare(b.item_code)).map((i) => (
          <tr key={i.key} className="border-b border-slate-200"><td className="w-8 py-2">☐</td><td className="py-2 font-mono">{i.item_code}</td><td className="py-2">{i.name}</td><td className="py-2 text-right font-bold">{i.qty_boxes} {u(i)}</td></tr>
        ))}</tbody>
      </table>
      {g.orders.map((o) => (
        <section key={o.local_id} className="mt-6 break-inside-avoid">
          <h3 className="font-semibold">{o.customer_name} · {o.doc_no}</h3>
          <ul className="mt-1 text-sm">{o.items.map((i) => <li key={`${i.item_code}:${i.uom}`} className="flex justify-between border-b border-dashed border-slate-200 py-1"><span>☐ {i.item_code} · {i.name}</span><span className="font-semibold">{i.qty_boxes} {u(i)}</span></li>)}</ul>
        </section>
      ))}
    </div>
  );
}
